import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import amplitude from 'amplitude-js'
import './i18n'

amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_KEY_V4,
  null,
  {
    saveEvents: true,
    includeUtm: true,
    includeReferrer: true,
    includeGclid: true
  })

  // !localStorage.getItem('jwt') && 
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  )

